module.exports = __webpack_public_path__ + "img/veranito_desktop.6b48a7d7.jpg";